// 包含本地数据
// import * as ISQ from '@/api/sq'
import utils from '@/utils/utils'

// 菜单数据
import { DBS, SQS, BKS }  from '@/data/MENU_CHECK'

// 菜单数据
import Menu from './data/Menu'
import DbMenu from './data/DbMenu'
import BKMenu from './data/BKMenu'

/**
 * 数据库、社区左侧菜单
*/
const LeftMenu = {
    namespaced: true,
    state: {
        // 菜单列表
        menu: {
            title: '数据库',
            isloaded: false,
            list: Menu,
        },

        // 路径信息
        cpm: {
            path: '/news',
            cid: 0,
        }
    },

    getters: {
        /**
        * 根据参数获得菜单
        */
        getMenu(state, pm) {
            return state.menu
        },

        /**
        * 获得子菜单
        */
        submenus ( state ) {
            return Menu[1].childs
        },

        /**
        * 获得子菜单
        */
        submenus2 ( state ) {
            return Menu[2].childs
        }
    },

    actions: {

        // 设置当前的路径参数
        setCpm (context, pm) {
            let rpm = pm || context.state.cpm

            // 数据库
            let dbs   = DBS
            let sqs   = SQS
            let bks   = BKS

            let menu = {}

            if ( utils.isinDBS(rpm) ) {
                menu = DbMenu
                context.commit('setTitle', '数据库')
            } else if ( utils.isinBKS(rpm) ) {
                menu = BKMenu
                context.commit('setTitle', '功能列表')
            } else {
                menu = Menu 
                context.commit('setTitle', '社区中心')
            }

            for (let idx in menu) {
                if ( rpm.path.includes(menu[idx].goto.path) ) {
                    menu[idx].class = 'is-open'
                } else {
                    menu[idx].class = ''
                }

                if (menu[idx].childs) {
                    for (let sidx in menu[idx].childs ) {
                        if (menu[idx].childs[sidx].id == rpm.cid) {
                            menu[idx].childs[sidx].class = 'is-sel'
                        } else {
                            menu[idx].childs[sidx].class = ''
                        }
                    }
                }
            }

            // 新闻二级菜单
            context.commit('setMenu', menu)
        },

        // 加载新闻分类
        loadNewsCat (context, pm) {
            // ISQ.getNewsCat().then(rlt => {
            //     let slist = []
            //     rlt.data.forEach(itm => {
            //         let sm = {}

            //         sm.id       = itm.id
            //         sm.title    = itm.name
            //         sm.goto     = {name: 'ncat', params: {cid: itm.id}}
            //         sm.class    = pm.cid == itm.id ? 'is-sel' : ''

            //         slist.push(sm)
            //     })

            //     // 更新数据
            //     Menu[0].childs = slist
            // })
        },

        // 加载讨论分类
        loadCommunityCat (context, pm) {
            // ISQ.getCommunityCat().then(rlt => {
            //     let slist = []
            //     rlt.data.forEach(itm => {
            //         let sm = {}

            //         sm.id       = itm.id
            //         sm.title    = itm.name
            //         sm.goto     = {name: 'ccat', params: {cid: itm.id}}
            //         sm.class    = pm.cid == itm.id ? 'is-sel' : ''

            //         slist.push(sm)
            //     })

            //     // 更新数据
            //     Menu[1].childs = slist
            // })
        },

        // 加载信息发布分类
        loadSlistCat (context, pm) {
            // ISQ.getSlistCat().then(rlt => {
            //     let slist = []
            //     rlt.data.forEach(itm => {
            //         let sm = {}

            //         sm.id       = itm.id
            //         sm.title    = itm.name
            //         sm.goto     = {name: 'scat', params: {cid: itm.id}}
            //         sm.class    = pm.cid == itm.id ? 'is-sel' : ''

            //         slist.push(sm)
            //     })

            //     // 更新数据
            //     Menu[2].childs = slist
            // })
        }
    },

    mutations: {
        setTitle(state, title) {
            state.menu.title = title
        },

        // 修改菜单列表
        setMenu (state, menu) {
            state.menu.list = menu
            state.menu.isloaded = true
        }
    }
}

export default LeftMenu